<template>
  <div class="home">
    
    <div >
            
            <!-- header -->
            <section v-if="!isDetailClient">
                <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 me-2">{{$t('products')}}</h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')">
                            </div>
                            <!-- Mobile filter toggle -->
                            <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                                <AppIcon name="bi-funnel" class="bi bi-funnel" />
                            </button>
                        </div>
                    </div>
                </div>
            </section>
            <!-- header -->

            <!-- table -->
            <section class="">
                <div class="px-8">

                <!-- Search shown when products are embedded in warehouse/category details -->
                <div v-if="isDetailClient && (warehouse_id || category_id)" class="detail-products-toolbar mb-4">
                    <div class="input-group detail-products-search">
                        <span class="input-group-text bg-white border-end-0">
                            <AppIcon name="bi-search" class="bi bi-search text-muted" />
                        </span>
                        <input
                            v-model.trim="search"
                            type="search"
                            class="form-control border-start-0"
                            autocomplete="off"
                            :placeholder="$t('search')"
                            :aria-label="$t('search')"
                            @keyup.enter="submitProductSearch"
                        >
                        <button
                            v-if="search"
                            type="button"
                            class="btn btn-outline-secondary"
                            :title="$t('clear_search')"
                            :aria-label="$t('clear_search')"
                            @click="clearProductSearch"
                        >
                            <AppIcon name="bi-x-lg" class="bi bi-x-lg" />
                        </button>
                    </div>
                </div>
                        
                <!-- Mobile action buttons (always visible) -->
                <div class="d-flex d-md-none gap-2 mb-3" v-if="!isDetailClient">
                    <template v-if="helper.checkAccess('create_inventories') != -1">
                        <button @click="create" class="btn btn-sm btn-success flex-grow-1">
                            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                            <span>{{$t('product')}}</span>
                        </button>
                    </template>
                    
                    <div class="dropdown">
                        <button class="btn btn-sm btn-light" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                            <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" />
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdownMenuButton">
                            <li v-if="helper.checkAccess('create_inventories') != -1">
                                <a class="dropdown-item" href="#" @click="showUplaod">{{$t('upload')}}</a>
                            </li>
                            <li>
                                <a class="dropdown-item" href="#" @click="generatePDF">{{$t('generate_pdf')}}</a>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- Filters section (collapsible on mobile, always visible on desktop) -->
                <div class="row align-items-end g-2 mb-4" v-if="!isDetailClient" :class="{'d-none d-md-flex': !showFilters}">
                    
                    <!-- Filter Dropdown (Shopify Style) -->
                    <div class="col-12 col-md-auto">
                        <div class="dropdown">
                            <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="filterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                                <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                            </button>
                            <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                            </button>
                            <div class="dropdown-menu p-3" aria-labelledby="filterDropdown" style="min-width: 300px;" @click.stop>
                                
                                <!-- Active Filters -->
                                <div v-if="activeFilters.length > 0" class="mb-3">
                                    <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                        <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                        <div class="input-group input-group-sm">
                                            <!-- Select type filter (e.g. status) -->
                                            <select v-if="filter.type === 'select'" v-model="filter.value" class="form-select form-select-sm">
                                                <option value="">{{$t('all')}}</option>
                                                <option v-for="opt in filter.options" :key="opt.value" :value="opt.value">{{$t(opt.label)}}</option>
                                            </select>
                                            <!-- Text type filter -->
                                            <input v-else type="text" v-model="filter.value" class="form-control form-control-sm" :placeholder="$t(filter.key)">
                                            <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                <AppIcon name="bi-trash" class="bi bi-trash" />
                                            </button>
                                        </div>
                                    </div>
                                    <hr class="dropdown-divider">
                                </div>

                                <!-- Add Filter Options -->
                                <div class="d-grid gap-2">
                                    <button v-for="filter in selectableFilters" :key="filter.key" 
                                            class="btn btn-sm btn-outline-primary text-start" 
                                            @click="addFilter(filter)">
                                        <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                                    </button>
                                </div>

                                <!-- Apply and Clear -->
                                <div class="d-flex justify-content-between align-items-center mt-3">
                                    <button class="btn btn-sm btn-success" @click="applyFilters">
                                        {{$t('apply')}}
                                    </button>
                                    <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                        {{$t('clear_all')}}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <!-- Spacer for desktop -->
                    <div class="col d-none d-md-block"></div>
                    
                    <!-- Date picker -->
                    <div class="col-12 col-md-3 col-lg-2">
                        <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                        <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                            <option value="">{{$t('filter_by_date')}}</option>
                            <option value="today">{{$t('today')}}</option>
                            <option value="yesterday">{{$t('yesterday')}}</option>
                            <option value="this_week">{{$t('this_week')}}</option>
                            <option value="last_week">{{$t('last_week')}}</option>
                            <option value="this_month">{{$t('this_month')}}</option>
                            <option value="custom">{{$t('custom_date')}}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                        <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                        <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                    </div>
                    
                    <!-- Desktop action buttons -->
                    <div class="col-md-2 d-none d-md-flex gap-2">
                        <template v-if="helper.checkAccess('create_inventories') != -1">
                            <button @click="create" class="btn btn-sm btn-success flex-grow-1">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('product')}}</span>
                            </button>
                        </template>
                       
                    </div>
                </div>

                <div class="page-table-container mb-6 bg-white rounded shadow">
                    
                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header v-if="visibleColumns.reference" field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getProducts)" />
                                    <th v-if="visibleColumns.image" class="pt-4 pb-3 px-6">{{$t('image')}}</th>
                                    <sortable-table-header v-if="visibleColumns.label" field="label" label="product_label" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getProducts)" />
                                    <!-- <th class="pt-4 pb-3 px-6">{{$t('sku')}}</th> -->
                                    <th v-if="visibleColumns.inventories" class="pt-4 pb-3 px-6">{{$t('inventories')}}</th>
                                    <th v-if="visibleColumns.supplier && helper.checkModuleIsEnabled('suppliers')" class="pt-4 pb-3 px-6">{{$t('supplier')}}</th>
                                    <th v-if="visibleColumns.category && helper.checkModuleIsEnabled('categories')" class="pt-4 pb-3 px-6">{{$t('category')}}</th>
                                    <!-- <th class="pt-4 pb-3 px-6">{{$t('purchase_price')}}</th> -->
                                    <th v-if="visibleColumns.price" class="pt-4 pb-3 px-6">{{$t('price')}}</th>
                                    <sortable-table-header v-if="visibleColumns.unity" field="unity" label="unity" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getProducts)" />
                                    <th v-if="visibleColumns.quantity" class="pt-4 pb-3 px-6">{{$t('quantity')}}</th>
                                    <th v-if="visibleColumns.warehouse && helper.checkModuleIsEnabled('warehouses')" class="pt-4 pb-3 px-6">{{$t('warehouse')}}</th>
                                    <th v-if="visibleColumns.status" class="pt-4 pb-3 px-6">{{$t('status')}}</th>
                                    <th v-if="visibleColumns.created_by" class="pt-4 pb-3 px-6">{{$t('created_by')}}</th>
                                    <sortable-table-header v-if="visibleColumns.created_at" field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getProducts)" />
                                    <th v-if="visibleColumns.action" class="pt-4 pb-3 px-6">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>{{$t('action')}}</span>
                                            <div class="dropdown">
                                                <button class="btn btn-sm btn-link p-0 ms-2" type="button" data-bs-toggle="dropdown" aria-expanded="false" title="Columns">
                                                    <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" />
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end p-2" style="min-width: 200px; max-height: 300px; overflow-y: auto;">
                                                    <li v-if="helper.checkAccess('create_inventories') != -1">
                                                        <a class="dropdown-item" href="#" @click="showUplaod">{{$t('upload')}}</a>
                                                    </li>
                                                    <li>
                                                        <a class="dropdown-item" href="#" @click="generatePDF">{{$t('generate_pdf')}}</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>

                            <tr v-for="product in products" :key="product.id" :class="{'table-active': product.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="product.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td v-if="visibleColumns.reference" class="py-5 px-6"> <router-link :to="`/products/${product.id}`"><b>{{product.reference}}</b></router-link></td>
                                <td v-if="visibleColumns.image" class="py-5 px-6"><img v-if="product.image" :src="product.image" alt="Product Image" style="max-height: 50px;"></td>
                                <td v-if="visibleColumns.label" class="py-5 px-6">{{product.label}}</td>
                                <!-- <td class="py-5 px-6">{{product.sku}}</td> -->
                                <td v-if="visibleColumns.inventories" class="py-5 px-6" @click="showInventories(product)" style="cursor:pointer;color:rgb(130, 127, 215)">{{product.inventories.length}}</td>
                                <td v-if="visibleColumns.supplier && helper.checkModuleIsEnabled('suppliers')" class="py-5 px-6"> <router-link v-if="product.supplier && product.supplier.id" :to="`/suppliers/${product.supplier.id}`">{{product && product.supplier.name ? product.supplier.name : '-'}}</router-link></td>
                                <td v-if="visibleColumns.category && helper.checkModuleIsEnabled('categories')" class="py-5 px-6">
                                    
                                    <router-link v-if="product?.category?.name" :to="`/categories/${product?.category?.id}`">{{product && product.category && product.category.name ? product.category.name : '-' }}</router-link>
                                </td>
                                <!-- <td class="py-5 px-6">
                                    <span v-if="product.inventories.length == 1">{{ formatMoney(product.inventories[0].purchase_price) }} </span>
                                    <span v-else style="cursor:pointer" @click="showInventories(product)" :class="sumInventories(product.inventories) > 0 ? 'badge bg-primary rounded-pill small' : 'badge bg-danger rounded-pill small'">{{$t('see_prices')}}</span>
                                </td> -->
                                <td v-if="visibleColumns.price" class="py-5 px-6">
                                    <span v-if="product.inventories.length == 1">{{formatMoney(product.inventories[0].price)}}</span>
                                    <span v-else style="cursor:pointer" @click="showInventories(product)" :class="sumInventories(product.inventories) > 0 ? 'badge bg-primary rounded-pill small' : 'badge bg-danger rounded-pill small'">{{$t('see_prices')}}</span>
                                </td>
                                <td v-if="visibleColumns.unity" class="py-5 px-6">{{product.unity || '-'}}</td>
                                <td v-if="visibleColumns.quantity" class="py-5 px-6">{{sumInventories(product.inventories)}}</td>
                                <td v-if="visibleColumns.warehouse && helper.checkModuleIsEnabled('warehouses')" class="py-5 px-6">
                                    <router-link v-if="product?.inventories?.length && product?.inventories[0].warehouse" :to="`/warehouses/${product?.inventories[0].warehouse.id}`">{{product?.inventories?.length && product?.inventories[0].warehouse ? product?.inventories[0].warehouse.name : '-'}}</router-link>
                                </td>
                                <td v-if="visibleColumns.status" class="py-5 px-6"> 
                                    <span :class="sumInventories(product.inventories) > 0 ? 'badge bg-success rounded-pill small' : 'badge bg-danger rounded-pill small'">{{sumInventories(product.inventories) > 0 ? $t('in_stock') : $t('out_of_stock')}}</span>&nbsp;
                                </td>
                                <td v-if="visibleColumns.created_by" class="py-5 px-6">
                                    {{ product.user ? product.user.name : '-'}}
                                </td>
                                <td v-if="visibleColumns.created_at" class="py-5 px-6">{{formatDate(product.created_at)}}</td>
                                <td v-if="visibleColumns.action" class="py-5 px-6">
                                    <button v-if="helper.checkAccess('edit_inventories') != -1" @click="editRow(product)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button> 
                                    <button v-if="helper.checkAccess('delete_inventories') != -1" @click="deleteRow(product)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <div v-if="loading === false && count > products.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getProducts" />
                        </div>


                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !products.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-box-seam" class="bi bi-box-seam text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_products_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_products') }}</p>
                        <template v-if="helper.checkAccess('create_inventories') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('add_first_product') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !products.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_product_found')}}.</div>
                </div>

                    <div class="col-sm-7">
                            {{$t('show')}}
                            <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            {{$t('entities')}}
                    </div>                    
                </div>
            </section>
            <!-- table -->

      </div>

        <!-- Bulk Action Bar -->
        <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
            <div class="d-flex align-items-center">
                <span class="fw-bold me-2">{{ selectedCount }}</span>
                <span class="text-muted">{{$t('selected')}}</span>
            </div>
            <div class="d-flex gap-2">
                <button v-if="helper.checkAccess('delete_inventories') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                    <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
                </button>
            </div>
        </div>

        <add-product v-if="createModalisOpen" :state="createModalisOpen" @createProduct="createProduct"></add-product>


        <!-- Edit Modal -->
        <div class="modal fade" id="edit-product-modal" tabindex="-1" aria-labelledby="edit-product-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header bg-light py-2">
                    <h5 class="modal-title mb-0">
                        <AppIcon name="bi-pencil" class="bi bi-pencil me-2" />
                        {{$t('edit_product')}}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div v-if="editModalisOpen === true" class="modal-body bg-white py-3" style="text-align:left; max-height: 75vh; overflow-y: auto;">
                    
                    <div class="row">
                        <!-- Left Column: Form Fields -->
                        <div class="col-lg-8">
                            <!-- Basic Information -->
                            <div class="section-header-compact mb-2">
                                <h6 class="text-muted mb-0 d-flex align-items-center">
                                    <AppIcon name="bi-info-circle" class="bi bi-info-circle me-2" />
                                    {{$t('basic_information')}}
                                </h6>
                            </div>

                            <div class="row">
                                <div v-if="visibleColumns.label" class="col-sm-7 mb-2">
                                    <label class="form-label-compact">
                                        {{$t('label')}} <span class="text-danger">*</span>
                                    </label>
                                    <input 
                                        v-model="product.label" 
                                        type="text" 
                                        class="form-control form-control-sm" 
                                        :placeholder="$t('name')"
                                    >
                                </div>
                                <div v-if="visibleColumns.sku" class="col-sm-5 mb-2">
                                    <label class="form-label-compact">{{$t('sku')}}</label>
                                    <input 
                                        v-model="product.sku" 
                                        type="text" 
                                        class="form-control form-control-sm" 
                                        :placeholder="$t('sku')"
                                    >
                                </div>
                                <div v-if="visibleColumns.supplier && helper.checkModuleIsEnabled('suppliers')" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('supplier')}}</label>
                                    <auto-complete  
                                        v-if="createSuplierState === false" 
                                        @emitAutoCompleteSupplier="emitAutoCompleteSupplier" 
                                        :defaultValue="product?.supplier?.name"
                                        entity="suppliers"
                                        emitEvent="emitAutoCompleteSupplier"
                                    ></auto-complete>
                                    <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateSupplierModal">
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_supplier')}}
                                    </a>
                                </div>
                                <div v-if="visibleColumns.category && helper.checkModuleIsEnabled('categories')" class="col-sm-4 mb-2"> 
                                    <label class="form-label-compact">{{$t('category')}}</label>
                                    <auto-complete  
                                        v-if="createCategoryState === false" 
                                        @emitAutoCompleteCategory="emitAutoCompleteCategory" 
                                        :defaultValue="product?.category?.name"
                                        entity="categories"
                                        emitEvent="emitAutoCompleteCategory"
                                    ></auto-complete>
                                    <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateCategoryModal">
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_category')}}
                                    </a>
                                </div>
                                <div v-if="!product.has_variants && visibleColumns.barcode" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('barcode')}}</label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            v-model="product.barcode" 
                                            type="text" 
                                            class="form-control" 
                                            :placeholder="$t('barcode')"
                                        >
                                        <button 
                                            class="btn btn-outline-secondary" 
                                            type="button" 
                                            @click="openBarcodeModal"
                                            :title="$t('barcode_options')"
                                        >
                                            <AppIcon name="bi-upc-scan" class="bi bi-upc-scan" />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <!-- Pricing -->
                            <div v-if="visibleColumns.price" class="section-header-compact mb-2 mt-3">
                                <h6 class="text-muted mb-0 d-flex align-items-center">
                                    <AppIcon name="bi-cash-coin" class="bi bi-cash-coin me-2" />
                                    {{$t('pricing')}}
                                </h6>
                            </div>

                            <div v-if="!product.has_variants" class="card bg-light border-0 mb-2 p-2">
                                <div class="form-check form-switch mb-0">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        id="toggleTTCEdit" 
                                        v-model="product.price_includes_tax"
                                    >
                                    <label class="form-check-label small" for="toggleTTCEdit">
                                        {{ product.price_includes_tax ? $t('price_with_tax') : $t('price_without_tax') }}
                                    </label>
                                </div>
                            </div>

                            <div class="row" v-if="!product.has_variants && product.price_includes_tax">
                                <div class="col-sm-6 mb-2">
                                    <label class="form-label-compact">{{$t('price_with_tax')}} <span class="text-danger">*</span></label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            v-model.number="product.price_with_tax" 
                                            type="number" 
                                            class="form-control" 
                                            min="0" 
                                            step="0.01" 
                                            inputmode="decimal"
                                            @input="calculatePriceFromTTC"
                                        >
                                        <span class="input-group-text">{{business.currency}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-6 mb-2">
                                    <label class="form-label-compact">{{$t('vat')}} %</label>
                                    <input 
                                        v-model.number="product.vat" 
                                        type="number" 
                                        class="form-control form-control-sm" 
                                        min="0" 
                                        max="100" 
                                        step="0.01" 
                                        inputmode="decimal"
                                        @input="calculatePriceFromTTC"
                                    >
                                </div>
                            </div>

                            <div class="row" v-if="!product.has_variants && visibleColumns.price">
                                <div v-if="visibleColumns.purchase_price" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('purchase_price')}} <span class="text-danger">*</span></label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            v-model.number="product.purchase_price" 
                                            type="number" 
                                            class="form-control" 
                                            min="0" 
                                            step="0.01" 
                                            inputmode="decimal"
                                        >
                                        <span class="input-group-text">{{business.currency}}</span>
                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('price')}} (HT) <span class="text-danger">*</span></label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            v-model.number="product.price" 
                                            type="number" 
                                            class="form-control" 
                                            min="0" 
                                            step="0.01" 
                                            inputmode="decimal"
                                            :readonly="product.price_includes_tax"
                                            :class="{'bg-light': product.price_includes_tax}"
                                            @input="!product.price_includes_tax && calculateTTCFromPrice()"
                                        >
                                        <span class="input-group-text">{{business.currency}}</span>
                                    </div>
                                    <small v-if="product.price_includes_tax" class="text-muted" style="font-size: 0.7rem;">
                                        <AppIcon name="bi-info-circle" class="bi bi-info-circle me-1" />{{$t('calculated_automatically')}}
                                    </small>
                                </div>
                                <div v-if="visibleColumns.profit_margin" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('profit_margin')}}</label>
                                    <div class="input-group input-group-sm">
                                        <input 
                                            type="text" 
                                            class="form-control bg-light" 
                                            :value="calculateMargin()" 
                                            readonly
                                        >
                                        <span class="input-group-text">%</span>
                                    </div>
                                </div>
                            </div>

                            <!-- Message when variants are enabled -->
                            <div v-if="product.has_variants" class="alert alert-info mb-2 py-2">
                                <small>
                                    <AppIcon name="bi-info-circle" class="bi bi-info-circle me-1" />
                                    {{$t('pricing_managed_per_variant')}}
                                </small>
                            </div>

                            <!-- Inventory -->
                            <div class="section-header-compact mb-2 mt-3">
                                <h6 class="text-muted mb-0 d-flex align-items-center">
                                    <AppIcon name="bi-box-seam" class="bi bi-box-seam me-2" />
                                    {{$t('inventories')}}
                                </h6>
                            </div>

                            <!-- Product Type Toggle -->
                            <!-- <div class="card bg-light border-0 mb-2 p-2">
                                <div class="form-check form-switch mb-0">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        id="toggleVariantsEdit" 
                                        v-model="product.has_variants"
                                        disabled
                                    >
                                    <label class="form-check-label small" for="toggleVariantsEdit">
                                        <strong>{{$t('product_has_variants')}}</strong>
                                        <br>
                                        <span class="text-muted" style="font-size: 0.75rem;">
                                            {{$t('enable_for_products_with_different_sizes_colors_etc')}}
                                        </span>
                                        <br>
                                        <span class="badge bg-warning text-dark mt-1" style="font-size: 0.7rem;">
                                            <AppIcon name="bi-info-circle" class="bi bi-info-circle me-1" />Cannot change variant setting when editing
                                        </span>
                                    </label>
                                </div>
                            </div> -->

                            <!-- Single Product Inventory (shown when has_variants is false) -->
                            <div v-if="!product.has_variants && (visibleColumns.quantity || visibleColumns.warehouse || visibleColumns.unity)" class="row">
                                <div v-if="visibleColumns.unity" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('unity')}}</label>
                                    <select v-model="product.unity" class="form-select form-select-sm">
                                        <option value="unit">{{$t('unit')}}</option>
                                        <option value="kg">kg</option>
                                        <option value="g">g</option>
                                        <option value="L">L</option>
                                        <option value="ml">ml</option>
                                        <option value="m">m</option>
                                        <option value="m²">m²</option>
                                    </select>
                                </div>
                                <div v-if="product.unity === 'm²'" class="col-sm-8 mb-2">
                                    <div class="card bg-light border-0 p-2">
                                        <label class="form-label-compact small text-primary mb-1">
                                            <AppIcon name="bi-calculator" class="bi bi-calculator me-1" />{{$t('carpet_area_helper')}}
                                        </label>
                                        <div class="row g-2">
                                            <div class="col-6">
                                                <div class="input-group input-group-sm">
                                                    <span class="input-group-text bg-white" style="font-size: 0.7rem;">W</span>
                                                    <input 
                                                        v-model.number="product.unity_width" 
                                                        type="number" 
                                                        class="form-control" 
                                                        placeholder="Width"
                                                        @input="calculateCarpetArea"
                                                    >
                                                </div>
                                            </div>
                                            <div class="col-6">
                                                <div class="input-group input-group-sm">
                                                    <span class="input-group-text bg-white" style="font-size: 0.7rem;">L</span>
                                                    <input 
                                                        v-model.number="product.unity_length" 
                                                        type="number" 
                                                        class="form-control" 
                                                        placeholder="Length"
                                                        @input="calculateCarpetArea"
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="visibleColumns.quantity" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('quantity')}} <span class="text-danger">*</span></label>
                                    <input 
                                        v-model.number="product.quantity" 
                                        type="number" 
                                        class="form-control form-control-sm" 
                                        step="0.001"
                                        min="0"
                                        inputmode="decimal"
                                    >
                                </div>
                                <div v-if="visibleColumns.min_quantity" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('min_quantity')}} <span class="text-danger">*</span></label>
                                    <input 
                                        v-model.number="product.min_quantity" 
                                        type="number" 
                                        class="form-control form-control-sm" 
                                        step="0.001"
                                        min="0"
                                        inputmode="decimal"
                                    >
                                </div>
                                <div v-if="visibleColumns.warehouse && helper.checkModuleIsEnabled('warehouses')" class="col-sm-4 mb-2">
                                    <label class="form-label-compact">{{$t('warehouse')}}</label>
                                    <auto-complete  
                                        v-if="createWarehouseState === false" 
                                        @emitAutoCompleteWarehouse="emitAutoCompleteWarehouse" 
                                        :defaultValue="product?.warehouse?.name"
                                        entity="warehouses"
                                        emitEvent="emitAutoCompleteWarehouse"
                                    ></auto-complete>
                                    <a href="#" class="related-create-link d-block mt-1 small text-decoration-none" @click.prevent="openCreateWarehouseModal">
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />{{$t('create_new_warehouse')}}
                                    </a>
                                </div>
                            </div>

                            <!-- Product Variants Section (shown when has_variants is true) -->
                            <div v-else class="variants-section">
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <h6 class="mb-0 small text-muted">
                                        <AppIcon name="bi-tag" class="bi bi-tag me-1" />
                                        {{$t('product_variants')}}
                                    </h6>
                                    <button 
                                        type="button" 
                                        @click="addVariant" 
                                        class="btn btn-sm btn-outline-primary"
                                        style="padding: 4px 12px; font-size: 0.8rem;"
                                    >
                                        <AppIcon name="bi-plus-circle" class="bi bi-plus-circle me-1" />
                                        {{$t('add_variant')}}
                                    </button>
                                </div>

                                <!-- Variants List -->
                                <div v-if="product.variants.length === 0" class="alert alert-info mb-2 py-2 px-2">
                                    <small>
                                        <AppIcon name="bi-info-circle" class="bi bi-info-circle me-1" />
                                        {{$t('no_variants_added_click_add_variant')}}
                                    </small>
                                </div>

                                <div v-for="(variant, index) in product.variants" :key="index" class="variant-card mb-2">
                                    <div class="card border">
                                        <div class="card-header bg-light py-2 px-2 d-flex justify-content-between align-items-center">
                                            <small class="fw-bold text-muted">
                                                <AppIcon name="bi-tag" class="bi bi-tag me-1" />
                                                {{$t('variant')}} #{{index + 1}}
                                            </small>
                                            <button 
                                                type="button" 
                                                @click="removeVariant(index)" 
                                                class="btn btn-sm btn-outline-danger"
                                                style="padding: 2px 8px; font-size: 0.75rem;"
                                            >
                                                <AppIcon name="bi-trash" class="bi bi-trash" />
                                            </button>
                                        </div>
                                        <div class="card-body p-2">
                                            <div class="row">
                                                <div class="col-md-6 mb-2">
                                                    <label class="form-label-compact">{{$t('variant_name')}} <span class="text-danger">*</span></label>
                                                    <input 
                                                        v-model="variant.name" 
                                                        type="text" 
                                                        class="form-control form-control-sm" 
                                                        :placeholder="$t('e_g_red_large_cotton')"
                                                    >
                                                    <small class="text-muted" style="font-size: 0.7rem;">{{$t('e_g_size_color_material')}}</small>
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('sku')}}</label>
                                                    <input 
                                                        v-model="variant.sku" 
                                                        type="text" 
                                                        class="form-control form-control-sm" 
                                                        :placeholder="$t('sku')"
                                                    >
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('barcode')}}</label>
                                                    <div class="input-group input-group-sm">
                                                        <input 
                                                            v-model="variant.barcode" 
                                                            type="text" 
                                                            class="form-control form-control-sm" 
                                                            :placeholder="$t('barcode')"
                                                        >
                                                        <button 
                                                            class="btn btn-outline-secondary dropdown-toggle" 
                                                            type="button" 
                                                            data-bs-toggle="dropdown" 
                                                            aria-expanded="false"
                                                            style="padding: 0.375rem 0.5rem; font-size: 0.75rem;"
                                                        >
                                                            <AppIcon name="bi-upc-scan" class="bi bi-upc-scan" />
                                                        </button>
                                                        <ul class="dropdown-menu dropdown-menu-end">
                                                            <li>
                                                                <a class="dropdown-item" href="#" @click.prevent="openVariantBarcodeModal(index, 'scan')">
                                                                    <AppIcon name="bi-camera" class="bi bi-camera me-2" />{{$t('scan_barcode')}}
                                                                </a>
                                                            </li>
                                                            <li>
                                                                <a class="dropdown-item" href="#" @click.prevent="generateVariantBarcode(index)">
                                                                    <AppIcon name="bi-upc" class="bi bi-upc me-2" />{{$t('generate_barcode')}}
                                                                </a>
                                                            </li>
                                                            <li v-if="variant.barcode">
                                                                <hr class="dropdown-divider">
                                                            </li>
                                                            <li v-if="variant.barcode">
                                                                <a class="dropdown-item" href="#" @click.prevent="downloadVariantBarcode(variant.barcode)">
                                                                    <AppIcon name="bi-download" class="bi bi-download me-2" />{{$t('download_barcode')}}
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('purchase_price')}} <span class="text-danger">*</span></label>
                                                    <input 
                                                        v-model.number="variant.purchase_price" 
                                                        type="number" 
                                                        class="form-control form-control-sm" 
                                                        min="0" 
                                                        step="0.01"
                                                        inputmode="decimal"
                                                    >
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('price')}} <span class="text-danger">*</span></label>
                                                    <input 
                                                        v-model.number="variant.price" 
                                                        type="number" 
                                                        class="form-control form-control-sm" 
                                                        min="0" 
                                                        step="0.01"
                                                        inputmode="decimal"
                                                    >
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('quantity')}} <span class="text-danger">*</span></label>
                                                    <input 
                                                        v-model.number="variant.quantity" 
                                                        type="number" 
                                                        class="form-control form-control-sm" 
                                                        step="0.001"
                                                        min="0"
                                                        inputmode="decimal"
                                                    >
                                                </div>
                                                <div class="col-md-3 mb-2">
                                                    <label class="form-label-compact">{{$t('min_quantity')}}</label>
                                                    <input 
                                                        v-model.number="variant.min_quantity" 
                                                        type="number" 
                                                        class="form-control form-control-sm" 
                                                        step="0.001"
                                                        min="0"
                                                        inputmode="decimal"
                                                    >
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <label class="form-label-compact">{{$t('variant_image')}}</label>
                                                    <div class="variant-image-upload">
                                                        <div v-if="variant.image" class="position-relative d-inline-block">
                                                            <img :src="variant.image" class="variant-preview-image" style="height: 100px;width: 100px;" alt="Variant">
                                                            <button 
                                                                type="button" 
                                                                @click="variant.image = null" 
                                                                class="btn btn-sm btn-danger position-absolute top-0 end-0 m-1"
                                                                style="padding: 2px 6px; font-size: 0.7rem;"
                                                            >
                                                                <AppIcon name="bi-x" class="bi bi-x" />
                                                            </button>
                                                        </div>
                                                        <div v-else>
                                                            <input 
                                                                type="file" 
                                                                :id="`variantFileInputEdit${index}`"
                                                                @change="handleVariantFileUpload($event, index)" 
                                                                accept="image/*" 
                                                                class="d-none"
                                                            >
                                                            <label 
                                                                :for="`variantFileInputEdit${index}`"
                                                                class="btn btn-sm btn-outline-secondary mb-0"
                                                                style="cursor: pointer;"
                                                            >
                                                                <AppIcon name="bi-image" class="bi bi-image me-1" />
                                                                {{$t('upload_image')}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Notes -->
                            <div v-if="visibleColumns.notes" class="mb-2 mt-3">
                                <collapsible-notes-field v-model="product.notes" id="product-edit-notes" rows="2" />
                            </div>
                        </div>

                        <!-- Right Column: Image Upload -->
                        <div v-if="visibleColumns.image" class="col-lg-4 mb-2">
                            <label class="form-label-compact">{{$t('image')}}</label>
                            <div class="image-preview">
                                <div 
                                    class="drop-zone-compact" 
                                    @dragover.prevent
                                    @drop.prevent="handleFileDrop"
                                    @click="$refs.fileInputEdit.click()"
                                    :class="{'has-image': product.image }"
                                >
                                    <img v-if="product.image" :src="product.image" class="preview-image-compact" alt="Product" />
                                    <div v-else class="drop-zone-content">
                                        <AppIcon name="bi-cloud-upload" class="bi bi-cloud-upload" style="font-size: 32px;" />
                                        <p class="mt-2 mb-1">{{$t('drag_drop_or_click')}}</p>
                                        <small class="text-muted" style="font-size: 0.75rem;">{{$t('max_size_5mb')}}</small>
                                        <!-- <span v-if="business && business.status !== 'active'" class="badge bg-secondary mt-2">{{$t('pro')}}</span> -->
                                    </div>
                                </div>
                            </div>
                            <input 
                                type="file" 
                                ref="fileInputEdit" 
                                @change="handleFileUpload" 
                                accept="image/*" 
                                class="d-none"
                            >

                            <!-- Calculation info -->
                            <div v-if="!product.has_variants && product.price_includes_tax && product.price_with_tax && product.vat" class="mt-2">
                                <div class="card bg-light border-0">
                                    <div class="card-body p-2">
                                        <small class="text-muted d-block mb-1"><strong>{{$t('price_calculation')}}:</strong></small>
                                        <small class="text-muted d-block">{{$t('price_with_tax')}}: {{ formatMoney(product.price_with_tax) }}</small>
                                        <small class="text-muted d-block">{{$t('vat')}}: {{ product.vat }}%</small>
                                        <hr class="my-1">
                                        <small class="text-dark d-block"><strong>{{$t('price')}} (HT): {{ formatMoney(product.price) }}</strong></small>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="modal-footer bg-light py-2">
                    <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">
                        <AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />
                        {{$t('close')}}
                    </button>
                    <button 
                        type="button" 
                        class="btn btn-sm btn-success" 
                        :disabled="loading || !isFormValid" 
                        @click="updateRow"
                    >
                        <AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />
                        {{loading ? $t('saving') : $t('edit')}}
                    </button>
                </div>
                </div>
            </div>
        </div>
        <!-- Edit modal -->


        <div class="modal fade" id="show-inventory-modal" tabindex="-1" aria-labelledby="show-inventory-modal" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                    <div class="modal-body" v-if="product && product.id" style="text-align:left">
                    
                        <inventory-component :product_id="product.id"></inventory-component>
                
                    </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="show-upload" tabindex="-1" aria-labelledby="show-upload" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('upload_products')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div v-if="showUploadModalisOpen === true" class="modal-body" style="text-align:left">

                <import-product></import-product>
             
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="getProducts()" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                </div>
                </div>
            </div>
        </div>


        <add-supplier v-if="createSuplierState" :state="createSuplierState" @createSupplier="createSupplier"/>

        <add-category v-if="createCategoryState" :state="createCategoryState" @createCategory="createCategory"/>

        <add-warehouse v-if="createWarehouseState" :state="createWarehouseState" @createWarehouse="createWarehouse"/>

        <!-- Barcode Modal -->
        <div class="modal fade" id="barcode-modal" tabindex="-1" aria-labelledby="barcode-modal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header bg-white border-bottom">
                        <h5 class="modal-title">{{$t('barcode_options')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                    </div>
                    <div class="modal-body bg-white">
                        <!-- Scan Mode -->
                        <div v-if="!barcodeScanning">
                            <div class="d-grid gap-3">
                                <button class="btn btn-lg btn-primary" @click="startBarcodeScanner">
                                    <AppIcon name="bi-camera-fill" class="bi bi-camera-fill me-2" />
                                    {{$t('scan_barcode')}}
                                </button>
                                <button class="btn btn-lg btn-success" @click="generateAndSetBarcode">
                                    <AppIcon name="bi-upc-scan" class="bi bi-upc-scan me-2" />
                                    {{$t('generate_barcode')}}
                                </button>
                            </div>
                        </div>

                        <!-- Scanner View -->
                        <div v-else>
                            <div class="text-center mb-3">
                                <p class="text-muted">{{$t('point_camera_at_barcode')}}</p>
                            </div>
                            <div class="position-relative" style="background: #000; border-radius: 8px; overflow: hidden;">
                                <video ref="barcodeVideo" autoplay playsinline style="width: 100%; height: 300px; object-fit: cover;"></video>
                                <canvas ref="barcodeCanvas" style="display: none;"></canvas>
                            </div>
                            <div class="mt-3 text-center">
                                <button class="btn btn-danger" @click="stopBarcodeScanner">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-2" />
                                    {{$t('cancel')}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import helper from '../../helper'
import autoComplete from '../../components/autocomplete/AutoComplete'
import inventoryComponent from '../../components/InventoryComponent.vue'
import AddSupplier from '../../components/AddSupplier.vue'
import addCategory from '../../components/AddCategory.vue'
import addWarehouse from '../../components/AddWarehouse.vue'
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import ImportProduct from '../../components/ImportProduct.vue'
import AddProduct from '../../components/AddProduct.vue'
import sortableList from '../../mixins/sortableList'
import { getInventoryProductColumnDefaults } from '../../constants/inventoryProductColumns'
// import axios from 'axios'

const maxAllowedSize = 5 * 1024 * 1024; //5MB

export default {
  mixins: [sortableList],
  name: 'Product',
  persistedFilterState: {
    key: 'products',
    fields: ['search', 'status', 'activeFilters', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  components : {
    autoComplete,
    AddSupplier,
    addWarehouse,
    addCategory,
    inventoryComponent,
    ImportProduct,
    AddProduct,
    DatePicker
  },
  props : ['user_id','warehouse_id','category_id','isDetailClient'],
  data(){
    return {
        timer_id : null,
        search : '',
        status : 'all',
        count : 0,
        page : 1,
        inventories : [],
        categories : [],
        suppliers : [],
        isSelectedItem : false,
        price_includes_tax: false,
        inventory : {
            purchase_price : "0",
            price : "0",
            quantity : "0",
            min_quantity : "0",
            product : {
                label : '',
                description : '',
                barcode : '',
                supplier_id : null,
                category_id : null,
                supplier : {
                    name : ''
                },
                category : {
                    name : ''
                },
                notes : '',
            price_includes_tax: false
            },
        },
        product : {
            label : '',
            vat : 0,
            description : '',
            image : null,
            barcode : '',
            supplier_id : null,
            category_id : null,
            notes : '',
            inventories : [],
            supplier : {
                name : ''
            },
            category : {
                name : ''
            },
            price_includes_tax: false,
            has_variants: false,
            variants: [],
            unity: 'unit',
            unity_width: null,
            unity_length: null,
            quantity: 0,
            min_quantity: 0,
            purchase_price: 0,
            price: 0,
            warehouse_id: null,
            warehouse: { name: '' }
        },
        showUploadModalisOpen : false,
        previewProductImage:null,
        range : [],
        start : null,
        end : null,
        dateRangeOption: '',
        products : [],
        createModal : null,
        editModal : null,
        createModalisOpen :false,
        editModalisOpen :false,
        showInventoryModalisOpen : false,
        showInventory : null,
        loading: false,
        createSuplierState : false,
        createCategoryState : false,
        createWarehouseState : false,
        per_page : 25,
        pagination : [],
        url : '',
        imagePreview : null,
        imageFile : null,
        showFilters: false,
        activeFilters: [],
        availableFilters: [
            { key: 'label' },
            { key: 'reference' },
            { key: 'sku' },
            { key: 'barcode' },
            { key: 'status', type: 'select', options: [
                { value: 'in_stock', label: 'in_stock' },
                { value: 'out_of_stock', label: 'out_of_stock' }
            ]}
        ],
        barcodeModal: null,
        barcodeScanning: false,
        barcodeStream: null,
        barcodeAnimationFrame: null,
        currentVariantIndex: null,
        barcodeMode: null, // 'product' or 'variant'
        visibleColumns: getInventoryProductColumnDefaults()
    }
  },
  mounted(){
    window.mixpanel.track("product");

    //check permissions
    if(helper.checkAccess('view_inventories') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_inventories') == -2) return this.$router.push({path : '/subscribe'})
    if(this.$route.query.create === 'true' && helper.checkAccess('create_inventories') != -1) {
      this.create()
    }

    // Initialize this_month date range
    // this.handleDateRangeChange()
    
    this.getProducts()
    // eslint-disable-next-line no-undef
    // this.createModal = new bootstrap.Modal(document.getElementById('create-product-modal'),{backdrop: 'static', keyboard: false})
    // document.getElementById('create-product-modal').addEventListener('hidden.bs.modal', () => { this.createModalisOpen = false })

    // eslint-disable-next-line no-undef
    this.editModal = new bootstrap.Modal(document.getElementById('edit-product-modal'),{backdrop: 'static', keyboard: false})
    document.getElementById('edit-product-modal').addEventListener('hidden.bs.modal', () => { this.editModalisOpen = false })

    // eslint-disable-next-line no-undef
    this.showInventory = new window.bootstrap.Modal(document.getElementById('show-inventory-modal'),{backdrop: 'static', keyboard: false})
    // document.getElementById('show-inventory-modal').addEventListener('hidden.bs.modal', () => { this.showInventoryModalisOpen = false })
    
    // eslint-disable-next-line no-undef
    this.showUplaodModal = new bootstrap.Modal(document.getElementById('show-upload'),{backdrop: 'static', keyboard: false})
    // document.getElementById('show-upload').addEventListener('hidden.bs.modal', () => { this.showUploadModalisOpen = false })

    // eslint-disable-next-line no-undef
    this.barcodeModal = new bootstrap.Modal(document.getElementById('barcode-modal'), {backdrop: 'static', keyboard: false})
    document.getElementById('barcode-modal').addEventListener('hidden.bs.modal', () => { 
      this.stopBarcodeScanner()
    })

  },
  created() {
    // Load column visibility settings
    this.loadColumnSettings()
  },    
  beforeUnmount() {
    // Clean up camera resources
    this.stopBarcodeScanner()
  },
  methods : {
    // Load column visibility settings from business metadata
    async loadColumnSettings() {
        if (this.business?.metadata?.inventory_products_columns) {
          this.visibleColumns = {
            ...this.visibleColumns,
            ...this.business.metadata.inventory_products_columns
          };
        }
    },
    // Calculate HT price from TTC price and VAT
    calculatePriceFromTTC() {
      if (this.product.price_with_tax && this.product.vat) {
        const priceWithTax = parseFloat(this.product.price_with_tax);
        const vatRate = parseFloat(this.product.vat) / 100;
        
        // Formula: HT = TTC / (1 + VAT_rate)
        this.product.price = (priceWithTax / (1 + vatRate)).toFixed(2);
      }
    },

    // Calculate TTC price from HT price and VAT
    calculateTTCFromPrice() {
      if (this.product.price && this.product.vat) {
        const price = parseFloat(this.product.price);
        const vatRate = parseFloat(this.product.vat) / 100;
        
        // Formula: TTC = HT * (1 + VAT_rate)
        this.product.price_with_tax = (price * (1 + vatRate)).toFixed(2);
      }
    },

    // Manual recalculation method (optional)
    recalculatePrice() {
      if (this.product?.price_includes_tax) {
        this.calculatePriceFromTTC();
      } else {
        this.calculateTTCFromPrice();
      }
    },
    generateBarcodeString(){
      // Format: <productId><YYYY><MM><DD><HH><mm><ss>
      const idPart = this.product && this.product.id 
        ? String(this.product.id) 
        : String(Math.floor(100000 + Math.random() * 900000))
      const now = new Date()
      const yyyy = String(now.getFullYear())
      const MM = String(now.getMonth() + 1).padStart(2, '0')
      const dd = String(now.getDate()).padStart(2, '0')
      const HH = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')
      return `${idPart}${yyyy}${MM}${dd}${HH}${mm}${ss}`
    },
    openBarcodeModal() {
      this.barcodeScanning = false
      this.barcodeMode = 'product'
      this.currentVariantIndex = null
      this.barcodeModal.show()
    },
    generateAndSetBarcode() {
      this.product.barcode = this.generateBarcodeString()
      this.barcodeModal.hide()
    },
    openVariantBarcodeModal(variantIndex, mode) {
      this.barcodeScanning = mode === 'scan'
      this.barcodeMode = 'variant'
      this.currentVariantIndex = variantIndex
      this.barcodeModal.show()
      
      if (mode === 'scan') {
        this.$nextTick(() => {
          this.startBarcodeScanner()
        })
      }
    },
    generateVariantBarcode(variantIndex) {
      const barcode = this.generateVariantBarcodeString(variantIndex)
      this.product.variants[variantIndex].barcode = barcode
    },
    generateVariantBarcodeString(variantIndex) {
      // Format: <productId or random><variant index><YYYY><MM><DD><HH><mm><ss>
      const idPart = this.product && this.product.id 
        ? String(this.product.id).substring(0, 6) 
        : String(Math.floor(100000 + Math.random() * 900000))
      const variantPart = String(variantIndex + 1).padStart(2, '0')
      const now = new Date()
      const yyyy = String(now.getFullYear()).substring(2) // Last 2 digits
      const MM = String(now.getMonth() + 1).padStart(2, '0')
      const dd = String(now.getDate()).padStart(2, '0')
      const HH = String(now.getHours()).padStart(2, '0')
      const mm = String(now.getMinutes()).padStart(2, '0')
      const ss = String(now.getSeconds()).padStart(2, '0')
      return `${idPart}${variantPart}${yyyy}${MM}${dd}${HH}${mm}${ss}`
    },
    downloadVariantBarcode(barcodeValue) {
      this.downloadBarcodeImage(barcodeValue)
    },
    downloadBarcodeImage(value) {
      try{
        if(!value) return
        const canvas = document.createElement('canvas')
        const scale = 4
        const width = 220 * scale
        const height = 80 * scale
        canvas.width = width
        canvas.height = height
        const ctx = canvas.getContext('2d')
        // background
        ctx.fillStyle = '#ffffff'
        ctx.fillRect(0,0,width,height)
        // draw simple bars based on digits
        const digits = value.replace(/[^0-9]/g,'').split('').map(n=>parseInt(n,10))
        let x = 20
        const barWidth = 2 * scale
        const barMaxHeight = 50 * scale
        for(let i=0;i<digits.length;i++){
          const h = (10 + (digits[i] % 10) * 4) * scale
          ctx.fillStyle = '#000000'
          ctx.fillRect(x, (height - barMaxHeight) / 2 + (barMaxHeight - h), barWidth, h)
          x += barWidth + 1 * scale
        }
        // text
        ctx.fillStyle = '#000000'
        ctx.font = `${12*scale}px monospace`
        ctx.textAlign = 'center'
        ctx.fillText(value, width/2, height - 10*scale)
        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = `barcode_${value}.png`
        link.click()
      }catch(e){
       alert('Barcode download error:', e)
      }
    },
    async startBarcodeScanner() {
      try {
        this.barcodeScanning = true
        
        // Request camera access
        const stream = await navigator.mediaDevices.getUserMedia({ 
          video: { facingMode: 'environment' } // Use back camera on mobile
        })
        
        this.barcodeStream = stream
        this.$refs.barcodeVideo.srcObject = stream
        
        // Start scanning loop
        this.scanBarcode()
      } catch (error) {
        alert('Error accessing camera:', error)
        this.$swal.fire({
          icon: 'error',
          title: this.$t('error'),
          text: this.$t('camera_access_denied')
        })
        this.barcodeScanning = false
      }
    },
    stopBarcodeScanner() {
      this.barcodeScanning = false
      
      // Stop camera stream
      if (this.barcodeStream) {
        this.barcodeStream.getTracks().forEach(track => track.stop())
        this.barcodeStream = null
      }
      
      // Cancel animation frame
      if (this.barcodeAnimationFrame) {
        cancelAnimationFrame(this.barcodeAnimationFrame)
        this.barcodeAnimationFrame = null
      }
      
      // Clear video source
      if (this.$refs.barcodeVideo) {
        this.$refs.barcodeVideo.srcObject = null
      }
    },
    async scanBarcode() {
      if (!this.barcodeScanning) return
      
      const video = this.$refs.barcodeVideo
      const canvas = this.$refs.barcodeCanvas
      
      if (video.readyState === video.HAVE_ENOUGH_DATA) {
        const context = canvas.getContext('2d')
        canvas.width = video.videoWidth
        canvas.height = video.videoHeight
        context.drawImage(video, 0, 0, canvas.width, canvas.height)
        
        const imageData = context.getImageData(0, 0, canvas.width, canvas.height)
        
        // Use BarcodeDetector API if available
        if ('BarcodeDetector' in window) {
          try {
            const barcodeDetector = new window.BarcodeDetector()
            const barcodes = await barcodeDetector.detect(imageData)
            
            if (barcodes.length > 0) {
              const detectedBarcode = barcodes[0].rawValue
              
              // Set barcode based on mode
              if (this.barcodeMode === 'variant' && this.currentVariantIndex !== null) {
                this.product.variants[this.currentVariantIndex].barcode = detectedBarcode
              } else {
                this.product.barcode = detectedBarcode
              }
              
              this.stopBarcodeScanner()
              this.barcodeModal.hide()
              
              this.$swal.fire({
                icon: 'success',
                title: this.$t('barcode_detected'),
                text: detectedBarcode,
                timer: 2000,
                showConfirmButton: false
              })
              return
            }
          } catch (error) {
            alert('Barcode detection error:', error)
          }
        }
      }
      
      // Continue scanning
      this.barcodeAnimationFrame = requestAnimationFrame(() => this.scanBarcode())
    },
    downloadBarcode(){
      const value = (this.product && this.product.barcode) ? String(this.product.barcode) : ''
      this.downloadBarcodeImage(value)
    },
    async handleFileUpload(event) {
        this.loading = true
        this.imageFile = null
        this.product.image = null
      const file = event.target.files[0];
      if (!file) {
          this.loading = false
          return;
      }

      // Create preview
      this.imageFile = file;
    if(file.size > maxAllowedSize) {
        this.loading = false
        return alert('File Too large please upload file less than 5mb')
    }
      this.product.image = URL.createObjectURL(file);
      try {
        await this.uploadImage()
      } catch (error) {
       this.$toast.error(error.message) 
      }
      this.loading = false
      this.event = null
    },
    async uploadImage() {
      if (!this.imageFile) return null;

      const url = await this.onUpload(this.imageFile);
        this.product.image = url
    },
    async onUpload(file){
        if(file.size > maxAllowedSize) return alert('File Too large please upload file less than 5mb')
        // if(this.business && this.business.status != 'active') return;
        return helper.customUploadFile(file,`businesses/${this.business.id}/attachments/${helper.generateRandString(20)}`,{products: true})
    },
    addVariant(){
        this.product.variants.push({
            name: '',
            sku: '',
            barcode: '',
            purchase_price: "0",
            price: "0",
            quantity: "0",
            min_quantity: "0",
            image: null
        })
    },
    onHasVariantsToggle(){
        // When enabling variants, automatically add the first variant if none exist
        if (this.product.has_variants && this.product.variants.length === 0) {
            this.addVariant()
        }
        // When disabling variants, clear the variants array
        if (!this.product.has_variants) {
            this.product.variants = []
        }
    },
    removeVariant(index){
        this.product.variants.splice(index, 1)
    },
    async handleVariantFileUpload(event, index) {
        const file = event.target.files[0];
        if (!file) return;
        
        if(file.size > maxAllowedSize) {
            alert('File Too large please upload file less than 5mb')
            return;
        }
        
        this.loading = true
        try {
            const url = await this.onUpload(file);
            this.product.variants[index].image = url;
        } catch (error) {
            this.$toast.error(error.message) 
        }
        this.loading = false
        event.target.value = null;
    },
    create(){
        this.createModalisOpen = true
    },
    createProduct(data){
        if(data && data.state != undefined){
            this.createModalisOpen = data.state
        }
        if(data && data.product){
            this.getProducts()
        }
    },
    editRow(row){
        this.imageFile = null
        this.editModalisOpen = true;
        
        // Deep copy the product to avoid mutations
        this.product = JSON.parse(JSON.stringify(row))
        
        // Initialize unity and helper fields
        this.product.unity = this.product.unity || 'unit'
        this.product.unity_width = null
        this.product.unity_length = null

        // If product has variants, populate quantity and min_quantity from inventory
        if (this.product.has_variants && this.product.variants && this.product.variants.length > 0) {
            this.product.variants = this.product.variants.map(variant => {
                // ... same variant logic ...
                if (!variant.name && variant.values && variant.values.length > 0) {
                    const nameValue = variant.values.find(v => v.option_name === 'Variant')
                    if (nameValue) {
                        variant.name = nameValue.option_value
                    }
                }
                
                if (variant.inventory) {
                    variant.quantity = variant.inventory.quantity || 0
                    variant.min_quantity = variant.inventory.min_quantity || 0
                    variant.purchase_price = variant.inventory.purchase_price || 0
                } else {
                    variant.quantity = variant.quantity !== undefined ? variant.quantity : 0
                    variant.min_quantity = variant.min_quantity !== undefined ? variant.min_quantity : 0
                    variant.purchase_price = variant.purchase_price !== undefined ? variant.purchase_price : 0
                }
                
                return variant
            })
        } else if (!this.product.has_variants && this.product.inventories && this.product.inventories.length > 0) {
            // For non-variant products, extract data from the first inventory
            const inventory = this.product.inventories[0]
            this.product.quantity = inventory.quantity || 0
            this.product.min_quantity = inventory.min_quantity || 0
            this.product.purchase_price = inventory.purchase_price || 0
            this.product.price = inventory.price || 0
            
            // Extract warehouse if available
            if (inventory.warehouse) {
                this.product.warehouse = inventory.warehouse
                this.product.warehouse_id = inventory.warehouse.id
            }
        }
        
        this.editModal.show()
    },
    calculateCarpetArea() {
        if (this.product.unity === 'm²') {
            const w = Number(this.product.unity_width) || 0;
            const l = Number(this.product.unity_length) || 0;
            if (w > 0 && l > 0) {
                this.product.quantity = parseFloat((w * l).toFixed(3));
            }
        }
    },
    showInventories(row){
        this.clearForm()
        this.showInventoryModalisOpen = true;
        this.product = row
        this.showInventory.show()
    },
    //crud
    //crud
    // saveRow method removed as it is now handled by AddProduct component
    async updateRow(){
        try{
            this.loading = true;
            
            // Prepare the payload
            const payload = { ...this.product }
            
            // If product has variants, clean up the variants array
            if (payload.has_variants && payload.variants && payload.variants.length > 0) {
                payload.variants = payload.variants.map(variant => ({
                    id: variant.id,
                    name: variant.name,
                    sku: variant.sku,
                    barcode: variant.barcode,
                    price: parseFloat(variant.price) || 0,
                    purchase_price: parseFloat(variant.purchase_price) || 0,
                    quantity: Number(variant.quantity) || 0,
                    min_quantity: Number(variant.min_quantity) || 0,
                    image: variant.image
                }))
            }
            
            // If product doesn't have variants, format the inventories array properly
            if (!payload.has_variants && payload.inventories && payload.inventories.length > 0) {
                // Update the first inventory with the form values
                payload.inventories[0] = {
                    ...payload.inventories[0],
                    quantity: Number(payload.quantity) || 0,
                    min_quantity: Number(payload.min_quantity) || 0,
                    purchase_price: parseFloat(payload.purchase_price) || 0,
                    price: parseFloat(payload.price) || 0,
                    warehouse_id: payload.warehouse_id || payload.inventories[0].warehouse_id
                }
            }
            
            await helper.customPatch(`${process.env.VUE_APP_API}/products/${this.product.id}`, payload)
            this.loading = false;
            this.clearForm()
            this.editModal.hide() 
            this.getProducts()
        }catch(error){
            this.loading = false;
        }

    },
    async deleteRow(row){
            this.$swal.fire({
                title: `${this.$t('are_you_sure')}?`,
                text : this.$t('you_cant_revert'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await helper.customDelete(`${process.env.VUE_APP_API}/products/${row.id}`)
                    this.products = helper.withoutDeletedRecords(this.products, row.id)
                    this.count = Math.max(0, this.count - 1)
                }
            })
    },
    clearForm(){
        this.product = {
            id : null,
            label : '',
            description : '',
            barcode : '',
            purchase_price : "0",
            price : "0",
            vat : this.business.vat || 0,
            quantity : "0",
            min_quantity : "0",
            unity : null,
            expiration_date : null,
            supplier_id : null,
            category_id : null,
            notes : '',
            image : null,
            // Use business default for new products, fallback to false
            price_includes_tax: this.business?.metadata?.price_includes_tax || false,
            has_variants: false,
            variants: []
        }
    },
    changeSelectedItem(){
        this.isSelectedItem = this.products.find(product => product.selected === true ) ? true : false
    },
    submitProductSearch() {
        clearTimeout(this.timer_id)
        this.getProducts()
    },
    clearProductSearch() {
        clearTimeout(this.timer_id)
        this.search = ''
    },
    async getProducts(page){
        try{
            this.loading = true
            this.page = page ? page : 1

            // Build query params
            const params = new URLSearchParams();
            params.append('page', this.page);
            params.append('per_page', this.per_page);
            this.appendSortParams(params);

            if (this.user_id) {
                params.append('user_id', this.user_id);
            }

            if (this.warehouse_id) {
                params.append('warehouse_id', this.warehouse_id);
            }

            if (this.category_id) {
                params.append('category_id', this.category_id);
            }

            if (this.start) {
                params.append('start', this.start);
                params.append('end', this.end);
            }

            if (this.search && this.search.length > 0) {
                params.append('keyword', this.search);
            }

            // Add Shopify-style active filters
            for (const filter of this.activeFilters) {
                if (filter.value && filter.value.toString().trim() !== '') {
                    params.append(filter.key, filter.value);
                }
            }

            let url = `${process.env.VUE_APP_API}/products?${params.toString()}`;

            this.products = []
            
            const response = await helper.customGet(url)
            this.products =  response.data.data

            for(let i = 0 ; i < this.products.length ; i++){
                this.$set(this.products[i], 'selected', false)
            }

            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }

            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }

            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    formatMoney(number) { return helper.formatMoney(number);},
    maxLengthBorder(length) { return helper.maxLengthBorder(length);},
    emitAutoCompleteSupplier(data){
        this.product.supplier_id = data.result.id
        this.product.supplier = data.result
    },
    emitAutoCompleteCategory(data){
        this.product.category_id = data.result.id
    },
    createSupplier(data){
        if(data.supplier){
            this.product.supplier_id = data.supplier.id
            this.product.supplier = data.supplier
        }
        if(data && data.state != undefined){
            this.createSuplierState = data.state
        }
    },
    createCategory(data){
        if(data.category){
            this.product.category_id = data.category.id
            this.product.category_id = data.category.id
            this.product.category = data.category
        }
        if(data && data.state != undefined){
            this.createCategoryState = data.state
        }
    },
    openCreateSupplierModal(){
        this.createSuplierState = !this.createSuplierState
    },
    openCreateCategoryModal(){
        this.createCategoryState = !this.createCategoryState
    },
    openCreateWarehouseModal(){
        this.createWarehouseState = !this.createWarehouseState
    },
    emitAutoCompleteWarehouse(data){
        if(data.index != undefined){
            this.product.inventories[data.index].warehouse = data.result
            this.product.inventories[data.index].warehouse_id = data.result.id
        }else{
            this.product.warehouse = data.result
            this.product.warehouse_id = data.result.id
        }
    },
    createWarehouse(data){
        if(data.warehouse){
            this.product.warehouse_id = data.warehouse.id
            this.product.warehouse = data.warehouse
        }
        if(data && data.state != undefined){
            this.createWarehouseState = data.state
        }
    },
    generatePDF() {
        const doc = new jsPDF();

        const data = []
        for(let i = 0 ; i < this.products.length ; i++){
            const product = this.products[i]
            
            data.push([
                product.reference,
                product.label,
                `${this.formatMoney(product.inventories[0].purchase_price)}`,
                `${this.formatMoney(product.inventories[0].price)}`,
                product.inventories[0].quantity,
                this.formatDate(product.created_at)
            ])
        }
        doc.text("Produits", 15, 10);
        autoTable(doc, {
            head: [[
                this.$t('reference'),
                this.$t('label'), 
                this.$t('purchase_price'),
                this.$t('price'),
                this.$t('quantity'),
                this.$t('created_at')
            ]],
            body: data
        })
        doc.save('produits.pdf')
    },
    generateCsv() {
        const data = []
        for(let i = 0 ; i < this.products.length ; i++){
            const product = this.products[i]
            data.push({
                "Étiquette" : product.label ,
                "Inventaires" : product.inventories.length,
                "Fournisseur" : product.supplier && product.supplier.name ? product.supplier.name : '-',
                "Catégorie" : product.product && product.category && product.category.name ? product.category.name : '-',
                "Crée à" : this.formatDate(product.created_at)
            })
        }

        return data
    },
    showUplaod(){
        this.showUploadModalisOpen = true;
        this.showUplaodModal.show()
    },
    sumInventories(inventories){
        let total = 0;
        for(let i = 0 ; i < inventories.length ; i++){
            total+=inventories[i].quantity
        }

        return total
    },
    calculateMargin() {
      const purchase = parseFloat(this.product.purchase_price) || 0;
      const sale = parseFloat(this.product.price) || 0;
      
      if (purchase === 0 || sale === 0) return '0.00';
      
      const margin = ((sale - purchase) / sale) * 100;
      return margin.toFixed(2);
    },
    handleFileDrop(event) {
        event.preventDefault();
        const files = event.dataTransfer.files;
        if (files.length > 0) {
            this.handleFileUpload({ target: { files: Array.from(files) } });
        }
    },
    // Handle date range selection
    handleDateRangeChange() {
      if (this.dateRangeOption === '') {
        // All dates - clear range
        this.range = []
        this.start = null
        this.end = null
        this.getProducts()
      } else if (this.dateRangeOption === 'today') {
        const start = new Date()
        const end = new Date()
        this.range = [start, end]
      } else if (this.dateRangeOption === 'yesterday') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'last_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_month') {
        const start = new Date()
        const end = new Date()
        start.setDate(1)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'custom') {
        // Don't set range yet, wait for user to pick dates
        this.range = []
      }
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.products.forEach(p => p.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.products.filter(p => p.selected).map(p => p.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/products/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.products = helper.withoutDeletedRecords(this.products, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('products_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    },
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            const newFilter = { 
                key: filter.key, 
                value: '' 
            };
            // Carry over type and options for select-type filters
            if (filter.type) {
                newFilter.type = filter.type;
                newFilter.options = filter.options;
            }
            this.activeFilters.push(newFilter);
        }
    },
    removeFilter(index) {
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    applyFilters() {
        this.getProducts();
    },
    clearAllFilters() {
        this.activeFilters = [];
        this.getProducts();
    }
  },
  watch : {
        // Watch for changes in price with tax
    'product.price_with_tax': function(newVal) {
      if (this.product?.price_includes_tax && newVal && this.product.vat) {
        this.calculatePriceFromTTC();
      }
    },

    // Watch for changes in VAT percentage
    'product.vat': function(newVal) {
      if (this.product?.price_includes_tax && this.product.price_with_tax && newVal) {
        this.calculatePriceFromTTC();
      }
    },

    // Watch for toggle changes
    price_includes_tax: function(newVal) {
      if (newVal && this.product.price && this.product.vat) {
        // When enabling TTC mode, calculate TTC from existing HT price
        this.calculateTTCFromPrice();
      } else if (!newVal && this.product.price_with_tax && this.product.vat) {
        // When disabling TTC mode, calculate HT price from TTC
        this.calculatePriceFromTTC();
      }
    },
    async search(){
        if(this.search.length > 2 || this.search.length === 0){
            clearTimeout(this.timer_id);
            this.timer_id = setTimeout(() => {
                this.getProducts()
            }, 500);
        }
    },
    range(){

        if(this.range[0] == null){
            this.start = null
            this.end = null
            this.getProducts()
        }else if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getProducts()
        }else{
            this.products = []
        }

    },
    per_page(){
        this.getProducts(this.page)
    }
  },
  computed : {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.isFilterActive(f.key));
    },
    isFiltered() {
      return (this.activeFilters.length > 0) || 
             (this.search && this.search.length > 0) ||
             (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.status && this.status !== 'all' && this.status !== '') ||
             (this.category_id && this.category_id !== '') ||
             (this.warehouse_id && this.warehouse_id !== '') ||
             (this.range && this.range.length > 0);
    },
    role(){ return this.$store.getters.ROLE },
    permissions(){ return this.$store.getters.PERMISSIONS },
    business(){ return this.$store.getters.BUSINESS },
    helper(){ return helper },
    isFormValid() {
      // Check required fields
      const hasLabel = this.product.label && this.product.label.length >= 2;
      
      // If product has variants, validate variants instead
      if (this.product.has_variants) {
        if (this.product.variants.length === 0) return false;
        
        // All variants must have name, purchase_price, price, and quantity
        const allVariantsValid = this.product.variants.every(variant => {
          return variant.name && 
                 variant.name.length >= 2 &&
                 variant.purchase_price !== null && 
                 variant.purchase_price !== undefined && 
                 parseFloat(variant.purchase_price) >= 0 &&
                 variant.price !== null && 
                 variant.price !== undefined && 
                 parseFloat(variant.price) >= 0 &&
                 variant.quantity !== null && 
                 variant.quantity !== undefined && 
                 parseFloat(variant.quantity) >= 0;
        });
        
        return hasLabel && allVariantsValid;
      } else {
        // Single product validation
        // const hasPurchasePrice = this.product.purchase_price && parseFloat(this.product.purchase_price) >= 0;
        // const hasPrice = this.product.price && parseFloat(this.product.price) >= 0;
        // const hasQuantity = this.product.quantity !== null && this.product.quantity !== undefined;
        // return hasLabel && hasPurchasePrice && hasPrice && hasQuantity;
        return hasLabel 
      }
    },
    areAllSelected() {
      return this.products.length > 0 && this.products.every(p => p.selected);
    },
    selectedCount() {
      return this.products.filter(p => p.selected).length;
    }
  }
}
</script>


<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }

    .detail-products-toolbar {
        display: flex;
        justify-content: flex-end;
    }

    .detail-products-search {
        max-width: 380px;
        width: 100%;
    }

    .section-header-compact h6 {
        color: #495057;
        font-size: 0.85rem;
        font-weight: 600;
        border-bottom: 1px solid #dee2e6;
        padding-bottom: 0.25rem;
    }

    .form-label-compact {
        font-size: 0.8rem;
        font-weight: 600;
        color: #495057;
        margin-bottom: 0.25rem;
        display: block;
    }

    .drop-zone {
        border: 2px dashed #ccc;
        border-radius: 8px;
        padding: 10px 15px;
        text-align: center;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 100px;
    }

    .drop-zone:hover:not(.disabled) {
        border-color: #534dff;
        background: #f8f9ff;
    }

    .drop-zone.disabled {
        cursor: not-allowed;
        opacity: 0.7;
    }

    .drop-zone.has-image {
        padding: 0;
        border: none;
    }

    .drop-zone-compact {
        border: 2px dashed #dee2e6;
        border-radius: 8px;
        padding: 15px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 280px;
        background: #f8f9fa;
    }

    .drop-zone-compact:hover:not(.disabled) {
        border-color: #0d6efd;
        background: #e7f1ff;
        transform: translateY(-2px);
        box-shadow: 0 2px 6px rgba(0,0,0,0.08);
    }

    .drop-zone-compact.disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    .drop-zone-compact.has-image {
        padding: 0;
        border: 2px solid #dee2e6;
        background: white;
    }

    .drop-zone-compact.has-image:hover {
        border-color: #0d6efd;
    }

    .preview-image {
        width: 100%;
        height: 200px;
        object-fit: cover;
        border-radius: 10px;
    }

    .preview-image-compact {
        width: 100%;
        height: 280px;
        object-fit: cover;
        border-radius: 6px;
    }

    .drop-zone-edit {
        border: 2px dashed #dee2e6;
        border-radius: 8px;
        padding: 10px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 150px;
        background: #f8f9fa;
    }

    .drop-zone-edit:hover:not(.disabled) {
        border-color: #0d6efd;
        background: #e7f1ff;
        transform: translateY(-2px);
        box-shadow: 0 2px 6px rgba(0,0,0,0.08);
    }

    .drop-zone-edit.disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    .drop-zone-edit.has-image {
        padding: 0;
        border: 2px solid #dee2e6;
        background: white;
    }

    .drop-zone-edit.has-image:hover {
        border-color: #0d6efd;
    }

    .preview-image-edit {
        width: 100%;
        height: 150px;
        object-fit: cover;
        border-radius: 6px;
    }

    .drop-zone-content {
        color: #6c757d;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
    }

    .drop-zone-content i {
        color: #0d6efd;
        font-size: 18px !important;
    }

    .modal-header.bg-light {
        background-color: #f8f9fa !important;
        border-bottom: 1px solid #dee2e6;
    }

    .modal-footer.bg-light {
        background-color: #f8f9fa !important;
        border-top: 1px solid #dee2e6;
    }

    .input-group-text {
        background-color: #e9ecef;
        border: 1px solid #ced4da;
        font-weight: 500;
        font-size: 0.8rem;
    }

    .text-danger {
        color: #dc3545 !important;
    }

    .card.bg-light {
        background-color: #f8f9fa !important;
    }

    a.text-decoration-none {
        color: #303030;
        transition: color 0.2s;
        font-size: 0.75rem;
        /* font-weight: 600; */
    }

    a.text-decoration-none:hover {
        color: #0d6efd;
    }

    /* Compact spacing */
    .modal-body {
        padding: 0.75rem 1rem;
    }

    .form-control-sm {
        padding: 0.375rem 0.5rem;
        font-size: 0.85rem;
    }

    .input-group-sm > .form-control {
        padding: 0.375rem 0.5rem;
        font-size: 0.85rem;
    }

    .input-group-sm > .input-group-text {
        padding: 0.375rem 0.5rem;
        font-size: 0.8rem;
    }

    /* Reduce alert padding */
    .alert {
        padding: 0.5rem 0.75rem;
    }

    /* Custom scrollbar for modal body */
    .modal-body::-webkit-scrollbar {
        width: 6px;
    }

    .modal-body::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    .modal-body::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 3px;
    }

    .modal-body::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
</style>

    /* Variant Styles */
    .variants-section {
        margin-top: 0.5rem;
    }

    .variant-card {
        animation: slideIn 0.3s ease-out;
    }

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .variant-card .card {
        transition: all 0.2s ease;
    }

    .variant-card .card:hover {
        box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    }

    .variant-preview-image {
        width: 100px;
        height: 100px;
        object-fit: cover;
        border-radius: 6px;
        border: 2px solid #dee2e6;
        display: block;
    }

    .variant-image-upload {
        padding: 0.75rem;
        background: #f8f9fa;
        border-radius: 6px;
        min-height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
